import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { LuCreditCard, LuCopy, LuPrinter } from 'react-icons/lu';
import { FaBarcode } from 'react-icons/fa';
import { FaPix } from 'react-icons/fa6';

import {
  CustomCard,
  CustomCardBody,
  CustomCardHeader,
} from '_components/Settings/components/SettingsV2/styles';
import { Button } from '_components/_core';
import { Box, BoxLabel, BoxValue, Value } from './styles';

const PAYMENT_METHOD_ICON = {
  CREDIT_CARD: <LuCreditCard className="mr-2" />,
  PIX: <FaPix className="mr-2" />,
  BOLETO: <FaBarcode className="mr-2" />,
  default: <LuCreditCard className="mr-2" />,
};

const ChargePaymentPix = ({ charge }) => {
  const handleCopyPixCode = useCallback(async () => {
    if (charge.pix_copia_cola) {
      await navigator.clipboard.writeText(charge.pix_copia_cola);
    }
  }, [charge]);

  return (
    <Row className="mt-3">
      <Col xs={12} md={6}>
        <Value>Pix</Value>
        <div className="d-flex align-items-center">
          <img
            width={200}
            height={200}
            src={`data:image/png;base64, ${charge.pix_qrcode_base64}`}
            alt="QR Code pix"
          />
          <p className="w-50">
            Acesse seu APP de pagamentos e faça a leitura do QR Code ao lado para efetuar
            o pagamento de forma rápida e segura.
          </p>
        </div>
      </Col>
      <Col
        className="d-flex align-items-center"
        style={{
          borderLeft: '1px solid #f1f1f4',
        }}
        xs={12}
        md={6}
      >
        <div>
          <Value>Código Pix copia e cola</Value>
          <div className="d-flex align-items-center">
            <p
              className="mt-3"
              style={{
                wordBreak: 'break-all',
              }}
            >
              {charge.pix_copia_cola}
            </p>
          </div>
          <Button
            onClick={handleCopyPixCode}
            className="d-flex justify-content-center align-items-center"
          >
            <LuCopy className="mr-2" />
            Copiar
          </Button>
        </div>
      </Col>
    </Row>
  );
};

const ChargePaymentBoleto = ({ charge }) => {
  const handleCopyBoletoCode = useCallback(async () => {
    if (charge.boleto_linha_digitavel) {
      await navigator.clipboard.writeText(charge.boleto_linha_digitavel);
    }
  }, [charge]);

  return (
    <>
      <Row className="mt-3">
        <Col xs={12} md={12} className="d-flex align-items-center">
          <Button
            variant="white"
            size="sm"
            className="d-flex align-items-center"
            onClick={() => window.open(charge.boleto_url, '_blank')}
          >
            <LuPrinter className="mr-2 text-success" />
            Imprimir boleto
          </Button>
          <Button
            variant="white"
            size="sm"
            className="d-flex align-items-center ml-2"
            onClick={handleCopyBoletoCode}
          >
            <LuCopy className="mr-2" />
            Copiar linha digitável
          </Button>
        </Col>
      </Row>
    </>
  );
};

function ChargePayment({ charge }) {
  const isInInvalidStatus = [
    'pendente',
    'aguardando provedor',
    'erro provedor',
    'cancelada',
  ].includes(charge.status_description.toLowerCase());

  return (
    <Row className="mt-3">
      <Col>
        <CustomCard>
          <CustomCardHeader>
            <h3>Pagamento da cobrança</h3>
          </CustomCardHeader>
          <CustomCardBody>
            <Row>
              <Col xs={6} md={4}>
                <Box>
                  <BoxLabel>Situação</BoxLabel>
                  <BoxValue status={charge.status_variant}>
                    {charge.status_description}
                  </BoxValue>
                </Box>
              </Col>
              <Col xs={6} md={4}>
                <Box>
                  <BoxLabel>Forma de pagamento</BoxLabel>
                  <BoxValue status={charge.status_variant}>
                    <span className="d-flex justify-content-start align-items-center text-capitalize">
                      {PAYMENT_METHOD_ICON[charge.payment_method_mnemonic]}
                      {charge.payment_method_name}
                    </span>
                  </BoxValue>
                </Box>
              </Col>
              <Col xs={6} md={3}>
                &nbsp;
              </Col>
            </Row>
            {!isInInvalidStatus && charge.status_description !== 'Recebida' && (
              <>
                {charge.payment_method_mnemonic === 'BOLETO' && (
                  <ChargePaymentBoleto charge={charge} />
                )}
                {charge.payment_method_mnemonic === 'PIX' && (
                  <ChargePaymentPix charge={charge} />
                )}
              </>
            )}
          </CustomCardBody>
        </CustomCard>
      </Col>
    </Row>
  );
}

ChargePayment.defaultProps = {
  charge: null,
};

ChargePayment.propTypes = {
  charge: PropTypes.object,
};

export default ChargePayment;
